import React, { useEffect, useRef } from 'react';
import { Countdown, BackgroundVideo, ResponsiveSpan, Section, LandingTitle, LandingText, AnniversaryText, StatisticsTextContainer, StatisticsText, StatisticsButtonContainer, StatisticsButton } from './styles';

import { EXTERNAL_LINKS } from '../../utils/links';
import background from '../../assets/Landing/test.mp4';
import statisticsHovered from '../../assets/Landing/statisticsHovered.png';
import statisticsDefault from '../../assets/Landing/statisticsDefault.png';
import Header from '../../components/Header/header';
import TimeBox from '../../components/Countdown/timebox';

const Landing: React.FC = () => {
  const [statsSrc, setStatsSrc] = React.useState(statisticsDefault);
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 0.5;
    }
  }, []);

  return (
    <Section id="home">
      <BackgroundVideo ref={videoRef} src={background} autoPlay loop muted playsInline>
        Your browser does not support the video tag.
      </BackgroundVideo>
      
      <Header />
      <LandingTitle>DUBHACKS '24</LandingTitle>
      <LandingText>University of Washington | Seattle, WA<br></br><b>October 12-13th, 2024</b></LandingText>
      <Countdown>
        <TimeBox />
      </Countdown>
      <AnniversaryText><b>Join us in celebrating 10 years of DubHacks!</b></AnniversaryText>
      <StatisticsTextContainer>
        <StatisticsText><b>12,000+</b><br></br><ResponsiveSpan>Participants</ResponsiveSpan></StatisticsText>
        <StatisticsText><b>400+</b><br></br><ResponsiveSpan>Mentors</ResponsiveSpan></StatisticsText>
        <StatisticsText><b>$100,000+</b><br></br><ResponsiveSpan>In Prizes</ResponsiveSpan></StatisticsText>
        <StatisticsText><b>1,500+</b><br></br><ResponsiveSpan>Projects Submitted</ResponsiveSpan></StatisticsText>
      </StatisticsTextContainer>
      <StatisticsButtonContainer>
        <StatisticsButton
          src={statsSrc}
          alt="Statistics"
          onMouseOver={() => setStatsSrc(statisticsHovered)}
          onMouseOut={() => setStatsSrc(statisticsDefault)}
          onClick={() => {
            window.open(EXTERNAL_LINKS['DH_STATS'], '_blank');
          }}
        />
      </StatisticsButtonContainer>
    </Section>
  );
}

export default Landing;